namespace $ {
	export function $mol_env() {
		return {} as Record< string, string | undefined >
	}
}
